// @ts-ignore
import Fingerprint2 from './lib/fingerprintjs2'

import  './lib/Evercookie'
// @ts-ignore
import uuidV4 from 'uuid/v4'
import {insert} from './lib/utils'
// @ts-ignore
import md5 from 'md5'
// @ts-ignore
import LuhnModNValidator from './lib/LuhnModNValidator'


const APP_VERSON='0000'
const VALIDATOR_VERSON = '01'
// 客户端字段
const CLIENT_FIELD_KEY = 'client_field'
//todo change
const DEVICEID2_KEY = 'deviceid2'
//eslint-disable-next-line
const ec = new Evercookie();

function getHash(str){
    str = md5(str)
    let hexString = ''
    str.split('').forEach(item=>{
        hexString+=item
    })
    return hexString

}

function getClientField(){
    return new Promise((resolve,reject)=>{
        try{
            ec.get(CLIENT_FIELD_KEY,(value)=>{
                if(value){
                    resolve(value)
                }else{
                    let tmp = uuidV4()
                    ec.set(CLIENT_FIELD_KEY,tmp)
                    resolve(tmp)

                }
            })
        }catch(e){
            reject(e)
        }

    })

}

function getFingerprint(){
    return new Promise((resolve,reject)=>{
            Fingerprint2.get((components)=>{
                try{
                    let fingerprint = ''
                    components.forEach(item=>{
                        let formatvalue = ''
                        if(item.value){
                            if(Array.isArray(item.value)){
                                // "plugins"/"canvas"/"webgl"/"fonts"/"enumerateDevices" Array<string>
                                formatvalue=item.value.toString()
                            }else if(typeof(item.value)=='boolean'){
                                formatvalue = item.value === true?'1':'0'
                            }else{
                                // "timeZoneOffset"/"deviceMemory"/"pixelRation" number类型
                                formatvalue=item.value.toString()
                            }
                        }
                        fingerprint+=formatvalue
                    })
                    resolve(fingerprint)
                }catch(e){
                    reject(e)
                    throw e;

                }

            })

    }).catch((e)=>{
        //eslint-disable-next-line
        console.error(e)
    })
}

function getFromEvercookie(){
    return new Promise((resolve)=>{

        ec.get(DEVICEID2_KEY,(value)=>{
            resolve(value)
        })
    })
}



export async function get() {
    try{
        let deviceid2 = await getFromEvercookie()
        if(deviceid2) return deviceid2;
        let fingerprint = await getFingerprint()

        let clientField = await getClientField()

        let str1 = getHash(fingerprint)
        let validDigit = LuhnModNValidator.computeCheckDigit(str1)
        // 将appversion值0000插入到第12位，str1.insert(12,0000);
        // 将校验算法版本值01插入到第16位，即str1.insert(16,01);
        // 将校验位值3插入到第20位，即str1.insert(20,3)，以上索引从0开始计
        str1 = insert(str1,12,APP_VERSON)
        str1 = insert(str1,20,VALIDATOR_VERSON)
        str1 = insert(str1,26,validDigit)

        let str2 = md5(clientField).slice(8,24)
        deviceid2 = str1+str2
        ec.set(DEVICEID2_KEY,deviceid2)
        return deviceid2;
    }catch(e){
        //eslint-disable-next-line
        console.error(e)
    }


}



export default {
    get,
}


